var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(
      !(
        (_vm.$vuetify.breakpoint.smAndDown && !_vm.$route.name) ||
        _vm.$route.name == 'help'
      )
    )?[(
        !(!_vm.$store.getters.getAppMode || _vm.$store.getters.getAppMode == 'APP')
      )?_c('Header'):_vm._e()]:_vm._e(),_c('sToastComponent',{class:this.$route.name}),_c('ErrorBoundary',{attrs:{"fall-back":_vm.fallBack}},[_c('v-content',{staticClass:"fixed-header-content",class:this.$route.name},[(
          !(
            (_vm.$vuetify.breakpoint.smAndDown && !_vm.$route.name) ||
            _vm.$route.name == 'help'
          )
        )?[(_vm.isLoading)?_c('div',{staticClass:"loadingDiv"},[_c('div',{staticClass:"lds-ellipsis"},[_c('div'),_c('div'),_c('div'),_c('div')]),_c('h1',[_vm._v("Loading...")])]):_vm._e()]:_vm._e(),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[(_vm.ifDataInStore)?_c('router-view'):_vm._e()],1)],2)],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }